import React, { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql } from "@apollo/client";
import FirmList from "../../../firms/FirmList";
import { Link, useNavigate } from "react-router-dom";
import FirmSubUpdate from '../../../firms/FirmSubUpdate';
import FirmSubUserUpdate from '../../../firms/FirmSubUserUpdate';
import ThemeContext from "../../../../context/ThemeContext";
import UserContext from '../../../../context/UserContext';
import { TabView, TabPanel } from 'primereact/tabview';
import { InputText } from "primereact/inputtext";
import { InputNumber } from 'primereact/inputnumber';
import { Fieldset } from 'primereact/fieldset';
import { RadioButton } from "primereact/radiobutton";
import { Button } from 'primereact/button';
import AgencyUpdateTest from './AgencyUpdateTest';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';

import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../lang/LangGlb';



const GET_POST = gql`
query MyQuery($firmCode: String!) {
    tbl_firm_sub_coop(where: {firm_sub_code_n: {_eq: $firmCode}}) {
    own_firm_main_code
    own_firm_sub_code
    own_firm_sub_type
    firm_main_code_n
    firm_sub_name_n
    firm_sub_code_n   
    int_ID
   
  }
  tbl_firm_sub_coop(where: {firm_sub_code_n: {_eq: $firmCode}}) {
    own_firm_main_code
    own_firm_sub_code
    own_firm_sub_type
    firm_main_code_n
    firm_sub_code_n
    firm_sub_name_n
    firm_sub_type_n
    int_ID
    
  }
  
  tbl_dpr_main_coop(
    where: { firm_sub_code_n: { _eq: $firmCode } }
    order_by: { dpr_main_code_n: asc }
  ) {
    own_firm_main_code
    own_firm_sub_code
    own_firm_sub_type
    firm_main_code_n
    firm_sub_code_n
    dpr_main_code_n
    dpr_main_name_n
    dpr_int_ID
    dpr_main_grp_code_n
  }

  tbl_dpr_sub_coop(
    where: { firm_sub_code_n: { _eq: $firmCode } }
    order_by: { dpr_sub_code_n: asc }
  ) {
    own_firm_code
    own_firm_sub_code
    own_firm_sub_type
    firm_main_code_n
    firm_sub_code_n
    dpr_main_code_n
    dpr_sub_code_n
    dpr_sub_name_n
    dpr_sub_type_n
    dpr_sub_n_int_ID
    dpr_sub_grp_code_n
  }
}
`;


const UPDATE_FIRM = gql`
mutation UpdateFirm(
 
  $firmCode: String!
  $firmName: String!
  ) {
  update_tbl_firm_sub_coop(
    where: { firm_sub_code_n: { _eq: $firmCode } }
    _set: { firm_sub_name_n: $firmName }
  ) {
    affected_rows
  }
}
`; 


const UPDATE_MAIN_DPR = gql`
mutation UpdateMainDpr(
 
  $firmCode: String!
  
  $ownFirmMainCode: String!
  $ownFirmSubCode: String!
  $ownFirmSubType: String!
  $dprMainCodeN: String!
  $dprMainNameN: String!
  ) {
  update_tbl_dpr_main_coop(
   
    where: {
      own_firm_main_code: { _eq: $ownFirmMainCode }
      own_firm_sub_code: { _eq: $ownFirmSubCode }
      own_firm_sub_type: { _eq: $ownFirmSubType }
      firm_sub_code_n: { _eq: $firmCode,  } 
      dpr_main_code_n: {_eq: $dprMainCodeN} }
    _set: { dpr_main_name_n: $dprMainNameN }
  ) {
    affected_rows
  }
}
`; 

const UPDATE_SUB_DPR = gql`
mutation UpdateSubDpr(
 
  $firmCode: String!
  
  $ownFirmMainCode: String!
  $ownFirmSubCode: String!
  $ownFirmSubType: String!
  $dprSubCodeN: String!
  $dprSubNameN: String!
  ) {
  update_tbl_dpr_sub_coop(
   
    where: {
      own_firm_code: { _eq: $ownFirmMainCode }
      own_firm_sub_code: { _eq: $ownFirmSubCode }
      own_firm_sub_type: { _eq: $ownFirmSubType }
      firm_sub_code_n: { _eq: $firmCode,  } 
      dpr_sub_code_n: {_eq: $dprSubCodeN} }
    _set: { dpr_sub_name_n: $dprSubNameN }
  ) {
    affected_rows
  }
}
`; 





const FirmDtl = () => {
  const { firm_sub_code_n } = useParams();
  const { loading, error, data, refetch, setData } = useQuery(GET_POST, {
    variables: { firmCode: firm_sub_code_n },
  });

  const navigate = useNavigate();


  


  const onEditorValueChange = (props, value) => {
    let updatedData = [...data.tbl_firm_sub_coop];
   updatedData[props.rowIndex][props.field] = value;
   setData({ tbl_firm_sub_coop: updatedData });
  };

  const updateFirm2 = (rowData) => {
    // Burada veritabanınızı veya veri kaynağınızı güncellemek için gerekli işlemleri gerçekleştirin.
    console.log('Güncellenen Veri:', rowData);
  };

  const handleCellEdit = (event) => {
    const updatedData = data.tbl_dpr_main_coop.map((item, index) => {
      if (index === event.index) {
        return {
          ...item,
          [event.field]: event.value,
        };
      }
      return item;
    });
  
    setData({ tbl_dpr_main_coop: updatedData });
  };

  
 
  const [updateFirm] = useMutation(UPDATE_FIRM);
  const [UpdateMainDpr] = useMutation(UPDATE_MAIN_DPR);
  const [UpdateSubDpr] = useMutation(UPDATE_SUB_DPR);
  

  const firmData = data && data.tbl_firm_sub_coop ? data.tbl_firm_sub_coop[0] : null;
  
  
 // const [firmCode, setFirmcode] = useState(firmData ? firmData.firm_main_code_n : "");
  const [firmName, setFirmName] = useState(firmData ? firmData.firm_sub_name_n : "");
  const [firmType, setFirmType] = useState(firmData ? firmData.firm_sub_type_n : "");
  const [place, setPlace] = useState(firmData ? firmData.place : "");
  const [fmActive, setFmActive] = useState(firmData ? firmData.active : true);
  const [activeTab, setActiveTab] = useState(0);

  const [openModal, setOpenModal] = useState(false);
  const [modalParam, setModalParam] = useState('');
  const [verim, setVerim] = useState('T0002');
  const {theme, setTheme} = useContext(ThemeContext);
  const {userName, setUserName} = useContext(ThemeContext);

  const { users } = useContext(UserContext);

  const ownFirmMainCode = users.firmcode;
  const ownFirmSubCode = users.subfirmcode;
  const ownFirmSubType = users.usertype;

  const [rows1, setRows1] = useState(10); 
  const [first1, setFirst1] = useState(0); 
  const paginatorLeft = <Button type="button" icon="pi pi-refresh" className="p-button-text" />; // paginatorLeft'i tanımlayın
  const paginatorRight = <Button type="button" icon="pi pi-cloud" className="p-button-text" />; // paginatorRight'ı tanımlayın
  
  
 
  
  const [dprMainCodeN, setDprMainCodeN] = useState(null); 
  const [dprMainNameN, setDprMainNameN] = useState (null);
  const [dprSubCodeN, setDprSubCodeN] = useState(null); 
  const [dprSubNameN, setDprSubNameN] = useState (null);

  const lang = users.userLang;
  const intl = useIntl();
  const currentLocale = users.userLang || localStorage.getItem('lang') || 'en';
  const close_form = messages[currentLocale].close_form;
  const new_firm = messages[currentLocale].new_firm;
  const search_by_firm_name = messages[currentLocale].search_by_firm_name;
  const firm_code = messages[currentLocale].firm_code;
  const firm_name = messages[currentLocale].firm_name;
  const firm_type = messages[currentLocale].firm_type;
  const typerec = messages[currentLocale].typerec;
  const placerec = messages[currentLocale].placerec;
  const time_zone = messages[currentLocale].time_zone;
  const update_firm = messages[currentLocale].update_firm;
  const int_id = messages[currentLocale].int_id;
  const currentPageReportTemplate = messages[currentLocale].currentPageReportTemplate;
  const statusrec = messages[currentLocale].statusrec;
  const detail = messages[currentLocale].detail;
  const create = messages[currentLocale].create;
  const update = messages[currentLocale].update;
  const activerec = messages[currentLocale].activerec;
  const inactiverec = messages[currentLocale].inactiverec;
  const definitions = messages[currentLocale].definitions;
  const managing_agency = messages[currentLocale].managing_agency;
  const firm_detail = messages[currentLocale].firm_detail;
  const agency_detail = messages[currentLocale].agency_detail;
  const sub_agency_detail = messages[currentLocale].sub_agency_detail;
  const main_department_tab = messages[currentLocale].main_department_tab;
  const sub_department_tab = messages[currentLocale].sub_department_tab;
  const rulesrec = messages[currentLocale].rulesrec;
  const account_cart_tab = messages[currentLocale].account_cart_tab;
  const bank_accounts_tab = messages[currentLocale].bank_accounts_tab;
  const main_department_code = messages[currentLocale].main_department_code;
  const main_department_name = messages[currentLocale].main_department_name;
  const sub_department_name = messages[currentLocale].sub_department_name;
  const main_code = messages[currentLocale].main_code;
  const sub_code = messages[currentLocale].sub_code;

  const administrator = messages[currentLocale].administrator;
  const dashboard = messages[currentLocale].dashboard
  const firm_update_successfully = messages[currentLocale].firm_update_successfully;
  const dpr_update_successfully = messages[currentLocale].dpr_update_successfully;

  const firm_main_code = messages[currentLocale].firm_main_code;
  const firm_sub_code = messages[currentLocale].firm_sub_code;
  const firm_sub_name = messages[currentLocale].firm_sub_name;

  const handleTabChange = (index) => {
    setActiveTab(index);
  };

 
  const textEditor = (props, rowData) => {
    const handleKeyPress = (e) => {
      if (e.keyCode === 13) {
        // Enter tuşuna basıldığında çalışacak işlemleri burada çağırın
        setDprMainNameN(props.value);
        setDprMainCodeN(rowData.dpr_main_code_n);
     
      }
    };
  
    return (
      <InputText
        type="text"
        value={props.value}
        onChange={(e) => props.editorCallback(e.target.value)}
        onKeyDown={handleKeyPress} // Enter tuşuna basıldığında handleKeyPress işlevi çalışacak
      />
    );
  };

  const textEditor2 = (props, rowData) => {
    const handleKeyPress = (e) => {
      if (e.keyCode === 13) {
        // Enter tuşuna basıldığında çalışacak işlemleri burada çağırın
        setDprSubNameN(props.value);
        setDprSubCodeN(rowData.dpr_sub_code_n);
     
      }
    };
  
    return (
      <InputText
        type="text"
        value={props.value}
        onChange={(e) => props.editorCallback(e.target.value)}
        onKeyDown={handleKeyPress} // Enter tuşuna basıldığında handleKeyPress işlevi çalışacak
      />
    );
  };
  


  const handleOpenModal = (param) => {
    setModalParam(param);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    refetch();
    
  };

  const handleOpenModal2 = (param) => {
    setModalParam(param);
    setOpenModal(true);
  };

  const handleCloseModal2 = () => {
    setOpenModal(false);
    
  };

  useEffect(() => {
    if (firmData) {
    //   setFirmcode(firmData.firm_main_code_n);
      setFirmName(firmData.firm_sub_name_n);
      setFirmType(firmData.firm_sub_type_n);
      setPlace(firmData.place);
      setFmActive(firmData.active);
    }
  }, [firmData]);

  useEffect(() => {
    if (dprMainNameN !== null) {
      // Bu kod yalnızca firmNameU değiştiğinde çalışır
      handleCellEditComplete();
      console.log('firmNameU değişti:', dprMainNameN);
      console.log('firmNameC değişti:', dprMainCodeN);
  
      // İşlemlerinizi burada gerçekleştirin, örneğin bir API çağrısı yapabilirsiniz
      // Örnek: makeApiCall(firmNameU);
    }
  }, [dprMainNameN]);

  useEffect(() => {
    if (dprSubNameN !== null) {
      // Bu kod yalnızca firmNameU değiştiğinde çalışır
      handleCellEditComplete2();
      console.log('firmNameU değişti:', dprSubNameN);
      console.log('firmNameC değişti:', dprSubCodeN);
  
      // İşlemlerinizi burada gerçekleştirin, örneğin bir API çağrısı yapabilirsiniz
      // Örnek: makeApiCall(firmNameU);
    }
  }, [dprSubNameN]);

  const handleCellEditComplete = (e) => {
    // Hücre düzenleme işlemi tamamlandığında çalışacak işlemleri burada gerçekleştirin
       
   handleUpdatemdpr();
  };

  const handleCellEditComplete2 = (e) => {
    // Hücre düzenleme işlemi tamamlandığında çalışacak işlemleri burada gerçekleştirin
       
    handleUpdatemdprsub();
  };

  const handleUpdatemdpr = () => { 
    
    UpdateMainDpr({
      variables: {
       
        dprMainNameN: dprMainNameN,
        dprMainCodeN: dprMainCodeN,
        firmCode: firmData.firm_sub_code_n,
        ownFirmMainCode: ownFirmMainCode,
        ownFirmSubCode : ownFirmSubCode,
        ownFirmSubType: ownFirmSubType,

            
        
      },
    })
      .then(() => {
        window.alert(dpr_update_successfully);
        refetch();
        console.log(dprMainNameN)
        console.log(dprMainCodeN)
      })
      .catch((error) => {
        console.error("Error updating firm:", error);
      });
  }; 

  const handleUpdatemdprsub = () => { 
    
    UpdateSubDpr({
      variables: {
       
        dprSubNameN: dprSubNameN,
        dprSubCodeN: dprSubCodeN,
        firmCode: firmData.firm_sub_code_n,
        ownFirmMainCode: ownFirmMainCode,
        ownFirmSubCode : ownFirmSubCode,
        ownFirmSubType: ownFirmSubType,

            
        
      },
    })
      .then(() => {
        window.alert(dpr_update_successfully);
        refetch();
        console.log(dprSubNameN)
        console.log(dprSubCodeN)
      })
      .catch((error) => {
        console.error("Error updating firm:", error);
      });
  }; 


  const handleUpdate = () => { 
    
    updateFirm({
      variables: {
       
        firmCode: firmData.firm_sub_code_n,
        firmName: firmName,
        
      },
    })
      .then(() => {
        window.alert(firm_update_successfully);
        refetch();
      })
      .catch((error) => {
        console.error("Error updating firm:", error);
      });
  }; 

  const getStatusLabel = (rowData) => {
    const statusClass = rowData.active
      ? "text-purple-800 font-bold text-xs"
      : "text-gray-500 font-bold text-xs";
  
    return (
      <div className={statusClass}>
      {rowData.active ? (
        <FormattedMessage id={activerec} />
      ) : (
        <FormattedMessage id={inactiverec} />
      )}
    </div>
    );
  };

  const onPageChange = (e) => {
    setFirst1(e.first);
    setRows1(e.rows1);
  }

  const userAndCreatedAtTemplate = (rowData) => {
    const dateTimeString = rowData.created_at; //"2023-09-27T08:45:36.735838+00:00"
    const dateObj = new Date(dateTimeString);
    const tarih = dateObj.toDateString(); // Tarih
    const saat = dateObj.toLocaleTimeString(); // Saat


  
    return (
      <div>
        <div className="text-xs">Kullanıcı: {rowData.create_user}</div>
        <div className="text-xs">Tarih: {tarih}</div>
        <div className="text-xs">Saat: {saat}</div>
      </div>
    );
  };






  const [isBankAccountsTabDisabled, setIsBankAccountsTabDisabled] = useState(true);



  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;
  if (!firmData) {
    return <p>No firm data found.</p>;
  }
  const items = [{ label: dashboard ,url: "/", target: '_self'},  { label: administrator ,url:"/htl/hotel-adm/main" }, { label: managing_agency ,url:"/htl/hotel-adm/firm/agency-list-coop" }, { label: sub_agency_detail }];

  return (

    
<div className="container p-2 mx-auto sm:p-4 dark:text-gray-100">
    <div className="grid grid-cols-3 gap-4">
      <div className="col-span-2 w-5/6">
        <nav>
          <ul className="flex border-solid rounded-md border-b outline-1">
            {items.map((item, index) => (
              <li key={index} className={`flex items-center m-1 ${index === items.length - 1 ? 'font-normal' : ''}`}>
                {index !== 0 && <span className={`mx-3 ${index === items.length - 1 ? '' : 'font-light'}`}> &gt; </span>}
                {item.url ? (
                  <Link to={item.url}>{item.label}</Link>
                ) : (
                  <span>{item.label}</span>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>
      <div className="col-span-1 mr-5 flex justify-end">
     
      <button onClick={() => navigate(-1)} className="text-violet-900 hover:text-violet-200 font-bold">{close_form}</button>
   
      </div>
     
  
    </div> 

   <div className="card mt-5 min-h-[40em]">
 
   <TabView className="flex m-0 p-0 list-none flex-nowrap" activeIndex={activeTab} onTabChange={(e) => handleTabChange(e.index)}>
   <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 0 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {firm_detail}
            </span>
          }
          className="ml-5 flex"
        >


      <p><div className=" p-2 ">
          <div className="card pt-1 mt-5 -ml-10 -my-10 font-thin"> 
            <Fieldset>
            <p className="my-0 font-medium ">

          <div className="flex gap-4">
          <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
    <label className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{firm_code}</label>
    <InputText className="w-full hover:border-violet-500 focus:outline-violet-300 focus:outline-offset-0 focus:shadow-[0_0_0_0.0,1px_rgba(192,121,153)]" 
    id="username" value={firmData.firm_sub_code_n}
    />
  </div>

  <div className="w-2/3 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{firm_name}</label>
    <InputText className="w-full" 
    id="firmname" value={firmName} 
    onChange={(e) => setFirmName(e.target.value)} />
  </div>
  <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{firm_type}</label>
    <InputText className="w-full" 
    id="firmtype" 
    name="firmtype"
    value={firmType}
    onChange={(e) => setFirmType(e.target.value)}
    readOnly/>
  </div>
  </div>

  
  <div className="flex gap-3 my-5">
    
  <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{firm_type}</label>
    <InputText className="w-full" 
    id="firmtype" 
    name="firmtype"
    value={firmType}
    onChange={(e) => setFirmType(e.target.value)}
    readOnly/>
  </div>

  

  <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="place">{placerec}</label>
    <InputText className="w-full" 
    id="place" 
    name="place"
    value={place} 
    onChange={(e) => setPlace(e.target.value)} />
  </div>

  <div className="w-1/6 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{time_zone}</label>
    <InputText className="w-full" 
    id="timezone" 
    name="timezone"
    value={place} 
    onChange={(e) => setPlace(e.target.value)} />
  </div>

  <div className=" flex-col font-medium  flex justify-content-center">
  
  <label htmlFor="firmtype" 
  className=" flex-col  ml-0 mb-5 align-items-center block font-medium text-gray-950 ">{statusrec} </label><p></p>
  <div className="flex ml-0 flex-wrap gap-6 ">
  <div className="flex ml-0 align-items-center ">
  <RadioButton inputId="ingredient1" name="active" value={true}  onChange={(e) => setFmActive(e.value)} checked={fmActive === true} />
          <label htmlFor="ingredient1" className="ml-2">{activerec}</label>
          
      </div>
      <div className="flex align-items-center">
          <RadioButton className="hover:border-violet-500 focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.1rem_rgba(227,203,244)]border-violet-500 checked:focus:shadow-[0_0_0_0.1rem_rgba(227,203,244)]border-violet-500"inputId="ingredient2" name="inactive" value={false}  onChange={(e) => setFmActive(e.value)} checked={fmActive === false} />
          <label htmlFor="ingredient2" className="ml-2 ">{inactiverec}</label>
      </div>
      </div>
      </div>  
      </div>
      <div className="mt-0 ">
        <Button label={update_firm} aria-label="Update" 
          className="purple-button p-button-sm p-button-outlined bg-violet-50 hover:bg-violet-900 text-white font-semibold  rounded-md"
          onClick={handleUpdate}  
        />
        </div>

</p>
         </Fieldset>
        </div>
        
   
        
             
        </div>          
      </p>  

</TabPanel>
<TabPanel header={
            <span
            className={`font-bold hover:border-b-2  cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
              activeTab === 1 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
              }`}
            >
              {agency_detail}
            </span>
          }
          className="ml-4"
        >

</TabPanel>


<TabPanel  header={
            <span
            className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
              activeTab === 2 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
              }`}
            >
             {main_department_tab}
            </span>
          }
          className="ml-4"
        >
        <br></br>

<p> <DataTable 
         value={data.tbl_dpr_main_coop } responsiveLayout="scroll"

         paginator
        
       //  paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
         currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
         rows={rows1} // Bu satırı verilerinize uygun şekilde ayarlayın
      //   rowsPerPageOptions={[10, 20, 50]}
         first={first1} // Bu satırı verilerinize uygun şekilde ayarlayın
      //   onPage={(e) => setFirst1(e.first)} 
     //    onRowsPerPageChange={(e) => setRows1(e.value)}
     //    paginatorLeft={paginatorLeft}
     //    paginatorRight={paginatorRight}
         tableStyle={{ minWidth: '50rem',  maxHeight: '40rem' }}
         onPageChange={onPageChange}
         editMode="cell"

         
        
        >
           <Column field="firm_main_code_n"
           className="text-xs text-right" 
           header={<span className="text-base font-semibold text-gray-900">{firm_main_code}</span>}
           style={{ textAlign: 'left', width: '10rem' }}
          >
          </Column>
          <Column field="firm_sub_code_n"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{firm_sub_code}</span>}
           style={{ textAlign: 'left', width: '10rem' }}
          >
          </Column>

          <Column field="dpr_main_code_n"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{main_department_code}</span>}
           style={{ textAlign: 'left', width: '10rem' }}
          >
          </Column>

      

          <Column
            field="dpr_main_name_n"
            header={<span className="font-bold text-gray-900">{main_department_name}</span>}
            className="text-sm selection:bg-purple-600  selection:text-cyan-100 w-30rem text-right " 
           style={{ textAlign: 'left', width: '30rem' }}
           tableStyle={{ textAlign: 'left', width: "w-12" }}
           
            editor={(props) => {
            const { rowData } = props;          
           const firmMainCode = (firmMainCode) => {      
           };
        

           return textEditor(props, rowData); // Sending parameters texteditor parametreleri text editore gonderiyorum
           }}
            />

         
          <Column field="place"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{placerec}</span>}
           style={{ textAlign: 'right', width: '6rem' }}
          >
          </Column>

          <Column field="ent_ID"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{int_id}</span>}
           style={{ textAlign: 'right', width: '6rem' }}
          >
          </Column>

          <Column
            field="active"
            body={getStatusLabel}
            header={<span className="font-bold text-gray-900">{statusrec}</span>}
            style={{ textAlign: 'left', width: '6rem' }}
            className="font-bold text-xs" 
          />
          

          <Column
          header={<span className="font-bold text-sm text-gray-900">{detail}</span>}
          body={(rowData) => (
            <button
              onClick={() => {
              //  handleOpenModal(rowData.firm_sub_code);
              //  setTheme(rowData.firm_sub_code);
              }}
              className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
            >
              <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
                <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
              </svg>
            </button>
          )}
          style={{ textAlign: 'center', width: '6rem' }}
        ></Column>

        
    
        </DataTable></p>
        {openModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
        <div className="fixed inset-0 bg-black opacity-5"></div>
        <div className="relative bg-white rounded-lg w-2/4 p-8 shadow-lg">
           
            <FirmSubUpdate />
           
            <button
              onClick={handleCloseModal}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
            >
              <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
                <path d="M6.71 6.71a1 1 0 0 1 1.42 0L12 10.59l3.88-3.88a1 1 0 0 1 1.42 1.42L13.41 12l3.89 3.88a1 1 0 1 1-1.42 1.42L12 13.41l-3.88 3.89a1 1 0 0 1-1.42-1.42L10.59 12 6.71 8.12a1 1 0 0 1 0-1.41z" />
              </svg>
            </button>
          </div>
        </div>
      )}

</TabPanel>


<TabPanel header={
            <span
            className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
              activeTab === 3 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
              }`}
            >
             {sub_department_tab}
            </span>
          }
          className="ml-4"
        >
          <br></br>


<p> <DataTable className="custom-header bg-purple-800"
         value={data.tbl_dpr_sub_coop } responsiveLayout="scroll"

         paginator
        
      //   paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
       //  currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
         rows={rows1} // Bu satırı verilerinize uygun şekilde ayarlayın
      //   rowsPerPageOptions={[10, 20, 50]}
      //   first={first1} // Bu satırı verilerinize uygun şekilde ayarlayın
      //   onPage={(e) => setFirst1(e.first)} 
         onRowsPerPageChange={(e) => setRows1(e.value)}
      //   paginatorLeft={paginatorLeft}
      //   paginatorRight={paginatorRight}
         tableStyle={{ minWidth: '50rem',  maxHeight: '40rem' }}
         onPageChange={onPageChange}
         editMode="cell"
         styleClass="custom-header"
       
        
        
        

         
        
        >
           <Column field="firm_main_code_n"
           className="text-xs text-right" 
           header={<span className="text-base font-semibold text-purple-950 rounded-s-2xl">{firm_code}</span>}
           style={{ textAlign: 'left', width: '8rem' }}
          >
          </Column>
          <Column field="firm_sub_code_n"
           className="text-xs text-right" 
           header={<span className="text-base font-semibold text-purple-900">{firm_sub_code}</span>}
           style={{ textAlign: 'left', width: '9rem' }}
          >
          </Column>

          <Column field="dpr_main_code_n"
           className="text-xs text-right" 
           header={<span className="text-base font-semibold text-purple-900"> {main_code}</span>}
           style={{ textAlign: 'left', width: '10rem' }}
          >
          </Column>

          <Column field="dpr_sub_code_n"
           className="text-xs text-right" 
           header={<span className="text-base font-semibold text-purple-900"> {sub_code}</span>}
           style={{ textAlign: 'left', width: '10rem' }}
          >
          </Column>   

          <Column
            field="dpr_sub_name_n"
            header={<span className="text-base font-semibold text-purple-900">{sub_department_name}</span>}
            className="text-sm w-30rem text-right " 
           style={{ textAlign: 'left', width: '30rem' }}
           tableStyle={{ textAlign: 'left', width: "w-12" }}
           
            editor={(props) => {
            const { rowData } = props;          
           const firmMainCode = (firmMainCode) => {      
           };
        

           return textEditor2(props, rowData); // Sending parameters texteditor parametreleri text editore gonderiyorum
           }}
            />

       



          <Column field="dpr_sub_type_n"
           className="text-xs text-right" 
           header={<span className="text-base font-semibold text-purple-900">{typerec}</span>}
           style={{ textAlign: 'left', width: '6rem' }}
          >
          </Column>

          <Column field="dpr_sub_n_int_ID"
           className="text-xs text-right" 
           header={<span className="text-base font-semibold text-purple-900">{int_id}</span>}
           style={{ textAlign: 'right', width: '6rem' }}
          >
          </Column>

          <Column
            field="active"
            body={getStatusLabel}
            header={<span className="text-base font-semibold text-purple-900">{statusrec}</span>}
            style={{ textAlign: 'left', width: '6rem' }}
            className="font-bold text-xs" 
          />
          

          <Column
          header={<span className="text-base font-semibold text-purple-900">{detail}</span>}
          body={(rowData) => (
            <button
              onClick={() => {
              //  handleOpenModal(rowData.firm_sub_code);
              //  setTheme(rowData.firm_sub_code);
              }}
              className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
            >
              <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
                <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
              </svg>
            </button>
          )}
          style={{ textAlign: 'center', width: '6rem' }}
        ></Column>

        
    
        </DataTable></p>
        {openModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
        <div className="fixed inset-0 bg-black opacity-5"></div>
        <div className="relative bg-white rounded-lg w-2/4 p-8 shadow-lg">
           
            <FirmSubUpdate />
           
            <button
              onClick={handleCloseModal}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
            >
              <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
                <path d="M6.71 6.71a1 1 0 0 1 1.42 0L12 10.59l3.88-3.88a1 1 0 0 1 1.42 1.42L13.41 12l3.89 3.88a1 1 0 1 1-1.42 1.42L12 13.41l-3.88 3.89a1 1 0 0 1-1.42-1.42L10.59 12 6.71 8.12a1 1 0 0 1 0-1.41z" />
              </svg>
            </button>
          </div>
        </div>
      )}

</TabPanel>


<TabPanel header={
            <span
            className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
              activeTab === 4 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
              }`}
            >
            {rulesrec}
            </span>
          }
          className="ml-4"
        >

<AgencyUpdateTest/>



</TabPanel>


<TabPanel
  header={<span className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden 
  ${isBankAccountsTabDisabled ? 'text-gray-500' : 'hover:border-purple-500'}`}>
    {account_cart_tab}
  </span>}
  className="ml-4"
  disabled={isBankAccountsTabDisabled}
>

<p> <DataTable
         value={data.tbl_dpr_main_coop } responsiveLayout="scroll"

         
        
        >
           <Column field="firm_main_code_n"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">Main Firm Code</span>}
           style={{ textAlign: 'left', width: '10rem' }}
          >
          </Column>
          <Column field="firm_sub_code_n"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">Main Sub Code</span>}
           style={{ textAlign: 'left', width: '10rem' }}
          >
          </Column>

          <Column field="firm_sub_name_n"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">Main Sub Name</span>}
           style={{ textAlign: 'left', width: '20rem' }}
          >
          </Column>

          <Column field="firm_sub_type_n"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">Firm Type</span>}
           style={{ textAlign: 'center', width: '7rem' }}
          >
          </Column>   

         
          <Column field="place"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">Place</span>}
           style={{ textAlign: 'right', width: '6rem' }}
          >
          </Column>

          <Column field="ent_ID"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">Int ID</span>}
           style={{ textAlign: 'right', width: '6rem' }}
          >
          </Column>

          <Column
            field="active"
            body={getStatusLabel}
            header={<span className="font-bold text-gray-900">Status</span>}
            style={{ textAlign: 'left', width: '6rem' }}
            className="font-bold text-xs" 
          />
          <Column
           field="created_at"
           header={<span className="font-bold text-xs text-gray-900">Create</span>}
           body={(rowData) => {
           const dateTimeString = rowData.created_at;
           const dateObj = new Date(dateTimeString);
           const formattedDate = `${dateObj.toLocaleDateString()} ${dateObj.toLocaleTimeString()}`;
            const createUser = rowData.create_user;

          return (
           <div className="text-xs">
           {createUser} - {formattedDate}
           </div>
            );
           }}
          style={{ textAlign: 'right', width: '6rem' }}
           />

<Column
           field="created_at"
           header={<span className="font-bold text-xs text-gray-900">Update</span>}
           body={(rowData) => {
           const dateTimeString = rowData.updated_at;
           const dateObj = new Date(dateTimeString);
           const formattedDate = `${dateObj.toLocaleDateString()} ${dateObj.toLocaleTimeString()}`;
            const createUser = rowData.update_user;

          return (
           <div className="text-xs">
           {createUser} - {formattedDate}
           </div>
            );
           }}
          style={{ textAlign: 'right', width: '6rem' }}
           />

          <Column
          header={<span className="font-bold text-sm text-gray-900">Detail</span>}
          body={(rowData) => (
            <button
              onClick={() => {
            //    handleOpenModal(rowData.firm_sub_code);
             //   setTheme(rowData.firm_sub_code);
              }}
              className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
            >
              <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
                <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
              </svg>
            </button>
          )}
          style={{ textAlign: 'center', width: '6rem' }}
        ></Column>

        
    
        </DataTable></p>
        {openModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
        <div className="fixed inset-0 bg-black opacity-5"></div>
        <div className="relative bg-white rounded-lg w-2/4 p-8 shadow-lg">
           
            <FirmSubUpdate />
           
            <button
              onClick={handleCloseModal}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
            >
              <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
                <path d="M6.71 6.71a1 1 0 0 1 1.42 0L12 10.59l3.88-3.88a1 1 0 0 1 1.42 1.42L13.41 12l3.89 3.88a1 1 0 1 1-1.42 1.42L12 13.41l-3.88 3.89a1 1 0 0 1-1.42-1.42L10.59 12 6.71 8.12a1 1 0 0 1 0-1.41z" />
              </svg>
            </button>
          </div>
        </div>
      )}
   
</TabPanel>


<TabPanel header={
            <span
            className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
              activeTab === 6 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
              }`}
            >
             {bank_accounts_tab}
            </span>
          }
          className="ml-4"
        >

</TabPanel>

</TabView>
 
    </div>
    </div>

    
       
 
 
);
};





export default FirmDtl;
